import React, { useState } from 'react';
import { getImageSrc } from '../../../util';

type Props = {
  className?: string;
};

const FSRMarginImpact: React.FC<Props> = ({ className }) => {
  const [withTableTab, set] = useState(true);
  return (
    <>
      <div className={`bg-gray-100 ${className}`} id={'margin-impact'}>
        <div className="max-w-7xl mx-auto py-16  lg:py-24">
          <div className="max-w-3xl mx-auto text-left">
            <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">
              Impact
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              {/* Built on modern technologies, with restaurants at heart */}{' '}
              Grow your margins
            </p>
          </div>
          <div className="mt-10">
            <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10 xl:gap-x-14">
              <div className="flex">
                <div className="">
                  <dt className="text-xl leading-6 font-medium text-primary-600">
                    Lower overhead
                  </dt>
                  <dd className="mt-8 lg:mt-2 text-base text-gray-500">
                    TableTab handles order and payment so your servers can cover
                    more tables and focus on what matters most - providing great
                    service. That's why we're your server's favorite colleague.
                  </dd>
                  <div className={'flex justify-center mt-10 group '}>
                    <span
                      onClick={() => set(true)}
                      className={`cursor-pointer inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium ${
                        withTableTab
                          ? 'bg-green-200 text-green-800 '
                          : 'bg-gray-200 text-gray-800'
                      } `}
                    >
                      With TableTab
                    </span>
                    <span
                      onClick={() => set(false)}
                      className={`cursor-pointer ml-4 inline-flex items-center  px-3 py-1.5  rounded-full text-xs font-medium bg-gray-100 ${
                        !withTableTab
                          ? 'bg-red-200 text-red-800 '
                          : 'bg-gray-200 text-gray-800'
                      }`}
                    >
                      Without TableTab
                    </span>
                  </div>
                  {withTableTab && (
                    <picture>
                      <source
                        srcSet={getImageSrc('product_impact_no.webp')}
                        type={'image/webp'}
                      />
                      <source
                        srcSet={getImageSrc('product_impact_no.png')}
                        type={'image/png'}
                      />
                      <img
                        className={
                          'lazyload mt-3 lg:p-11 md:p-4 p-2 rounded-lg shadow-lg bg-gray-50'
                        }
                        data-src={getImageSrc('product_impact_no.webp')}
                        alt={'lower overhead'}
                      />
                    </picture>
                  )}
                  {!withTableTab && (
                    <picture>
                      <source
                        srcSet={getImageSrc('product_impact_yes.webp')}
                        type={'image/webp'}
                      />
                      <source
                        srcSet={getImageSrc('product_impact_yes.png')}
                        type={'image/png'}
                      />
                      <img
                        className={
                          'lazyload mt-3 lg:p-11 md:p-4 p-2 rounded-lg shadow-lg bg-gray-50'
                        }
                        data-src={getImageSrc('product_impact_yes.webp')}
                        alt={'lower overhead'}
                      />
                    </picture>
                  )}

                  <div className="mt-4 md:mt-8">
                    {/*<h3 className="text-xs font-medium text-gray-900 tracking-wide uppercase">What's*/}
                    {/*    included</h3>*/}
                    <ul className="mt-6 space-y-4">
                      <li className="flex space-x-3">
                        <div
                          className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-green-200 text-white"
                        >
                          <svg
                            className="flex-shrink-0 h-4 w-4 text-green-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-base text-gray-500">
                          Increase server-to-table ratio
                        </span>
                      </li>

                      <li className="flex space-x-3">
                        <div
                          className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-green-200 text-white"
                        >
                          <svg
                            className="flex-shrink-0 h-4 w-4 text-green-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-base text-gray-500">
                          Decrease FOH labor costs
                        </span>
                      </li>

                      <li className="flex space-x-3">
                        <div
                          className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-green-200 text-white"
                        >
                          <svg
                            className="flex-shrink-0 h-4 w-4 text-green-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-base text-gray-500">
                          Mitigate risk of being understaffed
                        </span>
                      </li>

                      <li className="flex space-x-3">
                        <div
                          className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-green-200 text-white"
                        >
                          <svg
                            className="flex-shrink-0 h-4 w-4 text-green-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-base text-gray-500">
                          Avoid slowdown from staff turnover
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="flex">
                <div className="">
                  <dt className="text-xl leading-6 font-medium text-primary-600">
                    Increase revenue
                  </dt>
                  <dd className="mt-8 lg:mt-2 text-base text-gray-500">
                    TableTab's MiSO tech leverages an{' '}
                    <a
                      id={'Ba7FRR'}
                      className={'text-primary-600 hover:text-primary-700'}
                      href={
                        '/product?ref=product_overview_Ba7FRR_inline#order-pay'
                      }
                      onClick={e => {
                        // e.preventDefault();
                        // @ts-ignore
                        analytics.track('Order Pay Clicked', {
                          title: 'open_tab_digital_experience',
                          action: 'click',
                          location: 'fsr_impact',
                          destination: 'product_order_pay',
                        });
                        // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                      }}
                    >
                      {' '}
                      open tab digital experience
                    </a>{' '}
                    to capture impulse orders and incremental spend. Our
                    platform is built so you gain more orders from more tables.
                  </dd>
                  <picture>
                    <source
                      srcSet={getImageSrc('product_impact_graph_v1.webp')}
                      type={'image/webp'}
                    />
                    <source
                      srcSet={getImageSrc('product_impact_graph_v1.png')}
                      type={'image/png'}
                    />
                    <img
                      className={
                        'lazyload lg:p-10 md:p-4 p-2 mt-10 rounded-lg lg:mt-20 2xl:mt-20 shadow-lg bg-gray-50'
                      }
                      data-src={getImageSrc('product_impact_graph_v1.webp')}
                      alt={'increase revenue'}
                    />
                  </picture>
                  <div className="mt-4 md:mt-8">
                    {/*<h3 className="text-xs font-medium text-gray-900 tracking-wide uppercase">What's*/}
                    {/*    included</h3>*/}
                    <ul className="mt-6 space-y-4">
                      <li className="flex space-x-3">
                        <div
                          className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-green-200 text-white"
                        >
                          <svg
                            className="flex-shrink-0 h-4 w-4 text-green-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-base text-gray-500">
                          Leverage instant ordering to increase spending
                        </span>
                      </li>

                      <li className="flex space-x-3">
                        <div
                          className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-green-200 text-white"
                        >
                          <svg
                            className="flex-shrink-0 h-4 w-4 text-green-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-base text-gray-500">
                          Turn tables faster by removing payment process
                        </span>
                      </li>

                      <li className="flex space-x-3">
                        <div
                          className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-green-200 text-white"
                        >
                          <svg
                            className="flex-shrink-0 h-4 w-4 text-green-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-base text-gray-500">
                          Ensure every seat gets automatically upsold
                        </span>
                      </li>
                      <li className="flex space-x-3">
                        <div
                          className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-green-200 text-white"
                        >
                          <svg
                            className="flex-shrink-0 h-4 w-4 text-green-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-base text-gray-500">
                          Capture orders from any table at any moment
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </>
  );
};

export default FSRMarginImpact;
